import React, { useContext, useEffect, createContext } from "react";

// project-imports
import { showToast } from "../components/sweet-alert/Sweetalert";
import { getStats } from "./salesforce_api_context";
import {
  GET_STATS_BEGIN,
  GET_STATS_SUCCESS,
  GET_STATS_FAILURE,
  GET_FILTERED_STATS_BEGIN,
  GET_FILTERED_STATS_SUCCESS,
  GET_FILTERED_STATS_FAILURE,
} from "../constants/actions";
// import instructorData1 from '../data/instructor/InstructorData.json';
import statsDataWeeklyCourses from "../data/stats/courses-weekly-stats.json";
import statsDataMonthlyCourses from "../data/stats/courses-monthly-stats.json";
import statsDataYearlyCourses from "../data/stats/courses-yearly-stats.json";
import statsDataWeeklyBlogs from "../data/stats/blogs-weekly-stats.json";
import statsDataMonthlyBlogs from "../data/stats/blogs-monthly-stats.json";
import statsDataYearlyBlogs from "../data/stats/blogs-yearly-stats.json";

// third-party
import { useDispatch, useSelector } from "react-redux";
import {
  BLOGS,
  COURSES,
  MONTHLY,
  WEEKLY,
  YEARLY,
} from "../constants/entityType";

// Create context
export const StatsContext = createContext();

export const StatsProvider = (props) => {
  // Reading dispatch from Store
  const dispatch = useDispatch();

  // Constant variable
  const StatsData = useSelector((state) => state.stats);

  // Constant function

  // Function to get fetchStats
  const fetchStats = async (entityType, durationType) => {
    try {
      // Dispatching the action to begin the api calling process
      dispatch({ type: GET_STATS_BEGIN, payload: true });

      let response = {};
      // Calling API to get instructor
      // let response = await getStats();

      if (entityType === COURSES) {
        if (durationType === WEEKLY) {
          response =
            statsDataWeeklyCourses &&
            statsDataWeeklyCourses?.data &&
            Object.keys(statsDataWeeklyCourses?.data).length
              ? statsDataWeeklyCourses?.data
              : statsDataWeeklyCourses; // Change this to static data of the stats
        }
        if (durationType === MONTHLY) {
          response =
            statsDataMonthlyCourses &&
            statsDataMonthlyCourses?.data &&
            Object.keys(statsDataMonthlyCourses?.data).length
              ? statsDataMonthlyCourses?.data
              : statsDataMonthlyCourses; // Change this to static data of the stats
        }
        if (durationType === YEARLY) {
          response =
            statsDataYearlyCourses &&
            statsDataYearlyCourses?.data &&
            Object.keys(statsDataYearlyCourses?.data).length
              ? statsDataYearlyCourses?.data
              : statsDataYearlyCourses; // Change this to static data of the stats
        }
      }

      if (entityType === BLOGS) {
        if (durationType === WEEKLY) {
          response =
            statsDataWeeklyBlogs &&
            statsDataWeeklyBlogs?.data &&
            Object.keys(statsDataWeeklyBlogs?.data).length
              ? statsDataWeeklyBlogs?.data
              : statsDataWeeklyBlogs; // Change this to static data of the stats // Change this to static data of the stats
        }
        if (durationType === MONTHLY) {
          response =
            statsDataMonthlyBlogs &&
            statsDataMonthlyBlogs?.data &&
            Object.keys(statsDataMonthlyBlogs?.data).length
              ? statsDataMonthlyBlogs?.data
              : statsDataMonthlyBlogs; // Change this to static data of the stats // Change this to static data of the stats
        }
        if (durationType === YEARLY) {
          response =
            statsDataYearlyBlogs &&
            statsDataYearlyBlogs?.data &&
            Object.keys(statsDataYearlyBlogs?.data).length
              ? statsDataYearlyBlogs?.data
              : statsDataYearlyBlogs; // Change this to static data of the stats // Change this to static data of the stats
        }
      }

      // let response = statsData1 && statsData1?.data && Object.keys(statsData1?.data).length  ? statsData1?.data : statsData1; // Change this to static data of the stats

      // Dispatching the actions on success
      dispatch({ type: GET_STATS_SUCCESS, payload: response });

      // Showing the toast message on getting instructor data successfully
      // showToast("success", "Getting stats successfully ", true, "bottom-right", false, true, 5000);
    } catch (error) {
      console.log(
        "118 : stats_context : Error while getting stats::",
        error && JSON.stringify(error)
      );

      // Dispatching the actions on error
      dispatch({ type: GET_STATS_FAILURE, payload: error && error.message });

      // Showing the toast message on getting instructor unsuccessfully
      showToast(
        "error",
        error && error.message
          ? "We are unable to get the stats!"
          : "An error occurred",
        true,
        "bottom-right",
        false,
        true,
        5000
      );
    }
  };

  // Function to get fetchFilteredStats
  const fetchFilteredStats = async (entityType, durationType) => {
    try {
      // Dispatching the action to begin the api calling process
      dispatch({ type: GET_FILTERED_STATS_BEGIN, payload: true });

      let response = {};
      // Calling API to get instructor
      // let response = await getStats();

      if (entityType === COURSES) {
        if (durationType === WEEKLY) {
          response =
            statsDataWeeklyCourses &&
            statsDataWeeklyCourses?.data &&
            Object.keys(statsDataWeeklyCourses?.data).length
              ? statsDataWeeklyCourses?.data
              : statsDataWeeklyCourses; // Change this to static data of the stats
        }
        if (durationType === MONTHLY) {
          response =
            statsDataMonthlyCourses &&
            statsDataMonthlyCourses?.data &&
            Object.keys(statsDataMonthlyCourses?.data).length
              ? statsDataMonthlyCourses?.data
              : statsDataMonthlyCourses; // Change this to static data of the stats
        }
        if (durationType === YEARLY) {
          response =
            statsDataYearlyCourses &&
            statsDataYearlyCourses?.data &&
            Object.keys(statsDataYearlyCourses?.data).length
              ? statsDataYearlyCourses?.data
              : statsDataYearlyCourses; // Change this to static data of the stats
        }
      }

      if (entityType === BLOGS) {
        if (durationType === WEEKLY) {
          response =
            statsDataWeeklyBlogs &&
            statsDataWeeklyBlogs?.data &&
            Object.keys(statsDataWeeklyBlogs?.data).length
              ? statsDataWeeklyBlogs?.data
              : statsDataWeeklyBlogs; // Change this to static data of the stats // Change this to static data of the stats
        }
        if (durationType === MONTHLY) {
          response =
            statsDataMonthlyBlogs &&
            statsDataMonthlyBlogs?.data &&
            Object.keys(statsDataMonthlyBlogs?.data).length
              ? statsDataMonthlyBlogs?.data
              : statsDataMonthlyBlogs; // Change this to static data of the stats // Change this to static data of the stats
        }
        if (durationType === YEARLY) {
          response =
            statsDataYearlyBlogs &&
            statsDataYearlyBlogs?.data &&
            Object.keys(statsDataYearlyBlogs?.data).length
              ? statsDataYearlyBlogs?.data
              : statsDataYearlyBlogs; // Change this to static data of the stats // Change this to static data of the stats
        }
      }

      // let response = statsData1 && statsData1?.data && Object.keys(statsData1?.data).length  ? statsData1?.data : statsData1; // Change this to static data of the stats

      // Dispatching the actions on success
      dispatch({ type: GET_FILTERED_STATS_SUCCESS, payload: response });

      // Showing the toast message on getting instructor data successfully
      // showToast("success", "Getting stats successfully ", true, "bottom-right", false, true, 5000);
    } catch (error) {
      console.log(
        "214 : stats_context : Error while getting stats::",
        error && JSON.stringify(error)
      );

      // Dispatching the actions on error
      dispatch({
        type: GET_FILTERED_STATS_FAILURE,
        payload: error && error.message,
      });

      // Showing the toast message on getting instructor unsuccessfully
      showToast(
        "error",
        error && error.message
          ? "We are unable to get the stats!"
          : "An error occurred",
        true,
        "bottom-right",
        false,
        true,
        5000
      );
    }
  };

  useEffect(() => {
    fetchStats("courses", "weekly");
    fetchFilteredStats("courses", "weekly");
  }, []);

  return (
    <StatsContext.Provider
      value={{ ...StatsData, fetchStats, fetchFilteredStats }}
    >
      {props.children}
    </StatsContext.Provider>
  );
};
export const useStatsContext = () => {
  return useContext(StatsContext);
};
